import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 68 80" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 0v80h21.457a3.618 3.618 0 003.617-3.618V61.015h5.372c26.27 0 37.01-14.804 37.01-32.12 0-21.371-16.239-28.896-31.522-28.896H-.004" fillRule="evenodd" /></svg>);